const isMacOs = typeof navigator !== "undefined" && navigator.userAgent.includes("Mac");
export {
  isMacOs
};
//# sourceMappingURL=is-macos.js.map
